import SectionTitle from '../ui/section-title'

import ListingCardSkeleton from './listing-card-skeleton'

const ListingListSkeleton = () => {
  return (
    <section className="mb-6 flex flex-col gap-3">
      <SectionTitle
        title={
          <>
            Listings in user&apos;s area{' '}
            <span className="text-sm font-medium text-muted lg:text-[18px]">(calculating listings)</span>
          </>
        }
      />
      <div className="mt-4 grid grid-cols-[repeat(auto-fill,minmax(236px,1fr))] gap-4">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <ListingCardSkeleton key={i} />
        ))}
      </div>
    </section>
  )
}

export default ListingListSkeleton
